class TopProjectSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if(!isMobile()){
      const swiper = new Swiper("." + this.el, {
        loop: true,
        slidesPerView: 'auto',
        speed: 1000,
        spaceBetween: 50,
    
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    
        // Pagination
        pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
        },
    });
    }

    // 翻訳した時の分数表示対応
    window.addEventListener("DOMContentLoaded", switch_css);
    function switch_css(){
      console.log('tete');
      // クエリパラメータを取得
      let param = location.search
      let param_map = query_param_to_map(param);
      console.log(param_map)
      
      // クエリパラメータにmodeが無ければ何もしない
      if(!param_map.get("_x_tr_tl")){
        return
      }else{
        console.log('翻訳中です');
      }
      
      // クエリパラメータに応じたcssに切り替える
      // let css_url = param_map.get("mode") + ".css";
      // var linkstyle = document.getElementById('switch_css');
      // linkstyle.href = css_url;
    }
    // クエリパラメータを取得してMAPにする
    function query_param_to_map(param) {
      param = param.replace('?', '');
      let param_splitted = param.split('&');
      let param_map = new Map();
      param_splitted.forEach( val => {
          let splitted_val = val.split('=');
          param_map.set(splitted_val[0], splitted_val[1]);
      });
      return param_map ;
    }
  }
}
